//Listen. for modal close, and pause video on the close
$('#exampleModalLong').on('hidden.bs.modal', function (e) {
    $('video').trigger('pause');
})